"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorPage = require("./ErrorPage");
Object.keys(_ErrorPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPage[key];
    }
  });
});
